module.exports = __webpack_public_path__ + "components/media-kit/static/chris-a2e418b145618dd07216703117373e8a.png";